/**
 * MUI Chip color for progress photo pose type (front / side / back / other).
 */
export function getProgressPhotoTypeChipColor(type) {
  switch (type?.toLowerCase?.()) {
    case "front":
      return "primary";
    case "side":
      return "secondary";
    case "back":
      return "info";
    default:
      return "default";
  }
}
